<template>
  <div class="pstep">
    <div class="pstep__head">
      <h2 class="pstep__title">{{ $t("property.create.price.instructions") }}</h2>
    </div>

    <div class="pstep__card">
      <v-form lazy-validate v-model="valid" ref="form" class="pstep__form">
        <div
          v-for="operationType in fetchedProperty.operationTypes"
          :key="operationType"
          class="pstep__block"
        >
          <div class="pstep__label">
            {{ operationType == "sell" ? "Precio de venta" : "Precio de alquiler" }}
          </div>
          <div class="pstep__row">
            <v-autocomplete
              outlined
              dense
              hide-details
              :items="['ARS', 'USD']"
              label="Moneda"
              v-model="property[operationType == 'sell' ? 'sellCurrency' : 'currency']"
              class="pstep__cur"
            ></v-autocomplete>
            <v-text-field
              outlined
              dense
              hide-details
              :label="$t('property.create.price.fields.amount')"
              placeholder="15000"
              type="number"
              v-model="property[operationType == 'sell' ? 'sellPrice' : 'price']"
              class="pstep__amount"
            ></v-text-field>
            <v-checkbox
              hide-details
              color="primary"
              label="Ocultar al público"
              v-model="
                property.metadata[
                  operationType == 'sell' ? 'hide_sell_price' : 'hide_rent_price'
                ]
              "
              class="pstep__hide"
            ></v-checkbox>
          </div>
        </div>

        <div class="pstep__divider"></div>

        <div class="pstep__block">
          <div class="pstep__label">Expensas</div>
          <div class="pstep__row">
            <v-text-field
              outlined
              dense
              hide-details
              label="Gastos comunes"
              placeholder="15000"
              prefix="ARS"
              type="number"
              v-model="property.commonExpenses"
              class="pstep__amount"
            ></v-text-field>
          </div>
        </div>
      </v-form>
    </div>

    <div class="pstep__footer">
      <v-btn text color="primary" class="rounded-lg" @click="$router.go(-1)">
        {{ $t("action.close_and_continue_later") }}
      </v-btn>
      <v-btn color="accent" depressed class="rounded-lg" @click="nextStep">
        {{ fetchedProperty.state == "draft" ? $t("action.publish") : $t("action.save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { EditProperty } from "@/graphql/mutations/properties";

export default {
  data() {
    return {
      valid: true,
      property: {
        metadata: {
          hide_sell_price: false,
          hide_rent_price: false
        },
        price: 0,
        commonExpenses: 0,
        currency: "ARS",
        sellPrice: 0,
        sellCurrency: "ARS",
        state: "published"
      }
    };
  },

  props: {
    fetchedProperty: {
      type: Object,
      required: true
    }
  },

  mounted() {
    if (this.fetchedProperty.price) {
      let price = this.fetchedProperty.price.replace(/\D*/, "");
      this.property.price = parseInt(price.replace(".", ""));
      this.property.currency = this.fetchedProperty.currency || "ARS";
    }

    if (this.fetchedProperty.commonExpenses) {
      price = this.fetchedProperty.commonExpenses.replace(/\D*/, "");

      this.property.commonExpenses = parseInt(price.replace(".", ""));
    }

    if (this.fetchedProperty.metadata) {
      this.property.metadata = this.fetchedProperty.metadata;
    }

    if (this.fetchedProperty.sellPrice) {
      let price = this.fetchedProperty.sellPrice.replace(/\D*/, "");
      this.property.sellPrice = parseInt(price.replace(".", ""));
      this.property.sellCurrency = this.fetchedProperty.sellCurrency || "ARS";
    }
  },

  methods: {
    nextStep() {
      this.editProperty();
    },

    editProperty() {
      if (this.valid) this.$refs.form.validate();

      if (this.valid) {
        this.$apollo
          .mutate({
            mutation: EditProperty,
            variables: {
              input: {
                attributes: this.property,
                propertyId: this.fetchedProperty.id
              }
            }
          })
          .then(res => {
            this.$emit("continue", res.data.editProperty.property);
          });
      }
    }
  }
};
</script>

<style scoped>
.pstep__head { margin-bottom: 16px; }
.pstep__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}

.pstep__card {
  background: #fff;
  border: 1px solid #ece7de;
  border-radius: 14px;
  padding: 22px;
}

.pstep__block { margin-bottom: 6px; }
.pstep__label {
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #a39a8c;
  font-weight: 600;
  margin-bottom: 10px;
}

.pstep__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}
.pstep__cur { flex: none; width: 120px; }
.pstep__amount { flex: 1; min-width: 160px; }
.pstep__hide { flex: none; margin-top: 0; padding-top: 0; }
.pstep__hide >>> label { font-size: 13px; color: #56504a; }

.pstep__divider { height: 1px; background: #ece7de; margin: 16px 0 18px; }

.pstep__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.pstep__form >>> .v-text-field--outlined fieldset { border-radius: 10px; }
.pstep__form >>> .v-text-field--outlined.v-input--is-focused fieldset { border-color: #b52118; }

@media (max-width: 600px) {
  .pstep__cur,
  .pstep__amount { width: 100%; flex-basis: 100%; }
}
</style>
